import React, { Component } from 'react';
import jQuery from 'jquery';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';


import Header from './../../Header';
import Apvs from './../../APV/Apvs';
import ApvForm from './../../APV/ApvForm';

import ErrorBoundary from './../ErrorBoundary';

class ApvsEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "apvs" : [], 
            "apv" : {},
        };

        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
        this.loadAPV = this.loadAPV.bind(this);
        this.handleRedux = this.handleRedux.bind(this);

        this.load(props.match.params.id);
    }

    load(id)
    {
        Promise.all([
            Core.Instance.Request(Core.Address+"Client/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"APV/Client_id/"+id, null, "GET")
        ])
        .then((data) => {
            if(data[0] == null)
            {
                ErrorManager.Instance.Handle("Aucun client ne possède cet identifiant.");
                return;
            }
            this.setState({
                "client" : data[0],
                "apvs" : data[1] != null ? data[1] : [] 
            });
        });
    }

    loadAPV(id)
    {
        Core.Instance.Request(Core.Address+"APV/"+id, null, "GET")
        .then((data) => {
            if(data == null)
            {
                ErrorManager.Instance.Handle("Aucun avis ne possède cet identifiant.");
                return;
            }

            jQuery('#addAPVModal').modal('show');
            this.setState({
                "apv" : data 
            });
        });
    }

    handleRedux(event)
    {
        let apv = this.state.apv;
        apv[event.target.name] = event.target.value;
        this.setState({
            "apv" : apv
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.apv).length <= 0)
        {
            ErrorManager.Instance.Handle("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let apv = this.state.apv;
        //apv.date = apv.date != null ? apv.date/1000 : null;
        apv.Client_id = this.state.client.id;
        let request = null;

        if(apv.id){
            request = Core.Instance.Request(Core.Address+"APV/"+apv.id, apv, "PUT");
        }else{
            request = Core.Instance.Request(Core.Address+"APV", apv, "POST");
        }
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.client.id, "Enregistrement d'une entrée APV.");
        }).then(() => {
            ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            window.location.reload();
        });      
    }

    render()
    {
        document.title = "W-F: Apvs liés "+this.state.client.name + " " +this.state.client.first_name;

        return (
            <ErrorBoundary>
                <Header buttons={ [
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Historique APV</span>
                                        <span className="float-right" data-toggle="modal" data-target="#addAPVModal">
                                            <a href="#"><li className='fas fa-plus'></li> <u>Ajouter un APV</u></a>    
                                        </span>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Apvs apvs={ this.state.apvs } editing={ true } loadAPV={ this.loadAPV }/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ApvForm apv={ this.state.apv } onChange={ this.handleRedux } onSubmit={ this.submit } />
                </div>
            </ErrorBoundary>
        );
    }
}
export default ApvsEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/APV/ApvsEdit.js